import * as React from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import type { WalletCardInstructionProps } from './WalletCard.types'
import { cn } from '@core/utils'
import Avatar from '../Avatar/Avatar'
import Button from '../Button/Button'
import Icon from '../Icon/Icon'

const WalletCardInstruction: React.FC<WalletCardInstructionProps> = ({
    logo,
    name,
    date,
    dayJsFormat = 'DD/MM/YYYY',
    actionButtonText,
    actionButtonProps,
    className,
    ...props
}) => {
    const { t } = useTranslation()

    const formattedDate = React.useMemo(() => {
        if (!date) return ''

        return dayjs(date).format(dayJsFormat)
    }, [date, dayJsFormat])

    return (
        <button
            className={cn(
                'animate-enter flex h-[88px] w-full items-center gap-4 rounded-[20px] bg-semantic-background-primary pl-4 pr-6 text-left',
                className,
            )}
            {...props}>
            <Avatar className="h-12 w-12">
                <Avatar.Image
                    src={logo}
                    alt={name}
                    className="bg-white object-contain"
                />
            </Avatar>
            <div className="flex flex-grow flex-col">
                <h6 className="text-body-lg-b text-semantic-content-ink">
                    {name}
                </h6>
                <p className="text-body-sm-r text-semantic-content-inkMedium">
                    {formattedDate}
                </p>
            </div>
            <div className="flex items-center gap-2">
                <Button
                    asChild={true}
                    variant="primary"
                    size="tiny"
                    rounded="pill"
                    {...actionButtonProps}>
                    <span>
                        {actionButtonText ??
                            t(
                                'content_config.WalletCard.placeholder_edit_button_text',
                            )}
                    </span>
                </Button>
                <Icon
                    name="caret-right"
                    size={18}
                    color="var(--content-ink-light)"
                />
            </div>
        </button>
    )
}

export default WalletCardInstruction
